export const InternalDrawerState = {
  HIDDEN: 1,
  PARTICIPANT_LIST: 2,
  CHAT: 3,
  VIDEO: 4,
  SETTINGS: 5
};
